import TextImg from "./components/textimg/index.jsx";
import ImgVideo from "./components/imgvideo/index.jsx";

function Ai() {

    return (
        <div className="bg-black  flex items-center justify-center text-white">
            <TextImg />
            {/* <ImgVideo /> */}
        </div>
    );
}

export default Ai;
